import { safeImageSrcSet, safeImageUrl } from '../../../lib/sanity';
import type { UseCaseImage } from '../../../lib/useCaseQueries';
import { renderedImageDimensions } from '../../../lib/imageDimensions';

type UseCaseMediaProps = {
  image?: UseCaseImage;
  alt?: string;
  className?: string;
  width?: number;
  sizes?: string;
};

export function UseCaseMedia({ image, alt, className, width = 1280, sizes = '100vw' }: UseCaseMediaProps) {
  const url = image ? safeImageUrl(image, (b) => b.width(width).auto('format')) : undefined;
  const srcSet = image
    ? safeImageSrcSet(image, width, (b, candidateWidth) => b.width(candidateWidth).auto('format'))
    : null;
  if (!url) return null;

  const imageAlt = alt ?? image?.alt ?? '';
  const dimensions = renderedImageDimensions(image, width);

  return (
    <img
      src={url}
      srcSet={srcSet ?? undefined}
      alt={imageAlt}
      className={className}
      width={dimensions?.width}
      height={dimensions?.height}
      sizes={sizes}
      loading="lazy"
    />
  );
}
